import {AbstractModel, JsonObject, JsonProperty} from 'projects/core/src/public-api';
import {PricingCategory} from '../pricing-category';

@JsonObject('model.PricingMultiplication')
export class PricingMultiplication extends AbstractModel {
  @JsonProperty(Number, 'id')
  id?: number

  @JsonProperty(String, 'name')
  name?: string

  @JsonProperty(Number, 'value')
  value?: number

  @JsonProperty(String, 'applyToField')
  applyToField?: string

  @JsonProperty(String, 'operation')
  operation?: string

  @JsonProperty([PricingCategory], 'categories')
  categories?: PricingCategory[]
}

